// extracted by mini-css-extract-plugin
export var container = "_fw-0";
export var content = "_fw-3";
export var customerTitle = "_fw-4";
export var empty = "_fw-5";
export var gray = "_fw-6";
export var header = "_fw-7";
export var info = "_fw-8";
export var loading = "_fw-2";
export var loadingCard = "_fw-9";
export var oneLine = "_fw-a";
export var personName = "_fw-e";
export var pillContainer = "_fw-b";
export var selected = "_fw-1";
export var text = "_fw-c";
export var twoLines = "_fw-d";
export var unread = "_fw-f";
export var unreadIndicator = "_fw-g";